export class ReminderEmail {
    LoggedInUser: string;
    RequirementSubmissionRem1: string;
    RequirementSubmissionRem2: string;
    RequirementApprovalRem1: string;
    RequirementApprovalRem2: string;
    CostApprovalRem1: string;
    CostApprovalRem2: string;
    MaterialAllocationRem1: string;
    MaterialAllocationRem2: string;
    DispatchToSDRem1: string;
    DispatchToSDRem2: string;
    DispatchToFieldTeamRem1: string;
    DispatchToFieldTeamRem2: string;
}
export class GetReminderDataModel
    {
        formId :string;
        reminder1Day :string;
        reminder2Day :string;
    }